/** SVG attribute values that every hand-authored `<svg>` in the tree repeats verbatim. Both are protocol constants,
 * not style choices: `SVG_NAMESPACE` is the W3C-pinned XML namespace URI `createElementNS` requires, and
 * `SVG_VIEWBOX_24` is the 24x24 coordinate box the icon set is drawn on. `QUAL-NO-INLINE-UI-LITERALS-001` and the
 * `no-inline-ui-literals` ESLint rule both read `SVG_VIEWBOX_24` and forbid the raw literal at a JSX attribute.
 */

/** The 24x24 `viewBox` attribute value the icon set is drawn on. */
export const SVG_VIEWBOX_24 = '0 0 24 24';

/** The W3C SVG XML namespace URI -- required by `createElementNS` and by inline `xmlns=` on a data-URI SVG. */
export const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

// SVG MARKUP

/** The opening of an inline `<svg` element in markup -- the token the inline-SVG rules sniff a file for and anchor a site on. */
export const INLINE_SVG_OPENER = '<svg';
